import { useMemo, useState } from "react";
import { Modal } from "react-bootstrap";

import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { addCurrentThemeClassToEle, formatNumber } from "@/utils"
import ReadMore from "@/components/common/readMore"

import Share from "@/assets/icons/share.png";
import WhiteShare from "@/assets/icons/whiteShare.png";

import BlackWarning from "@/assets/icons/blackWarning.png";
import WhiteWarning from "@/assets/icons/whiteWarning.png";

import DislikeUnfilled from "@/assets/icons/dislikeUnfilled.png";
import DislikeFilled from "@/assets/icons/dislikeFilled.png";

import WhiteDislikeUnfilled from "@/assets/icons/whiteDislikeUnfilled.png";
import WhiteDislikeFilled from "@/assets/icons/whiteDislikeFilled.png";

import LikeUnfilled from "@/assets/icons/likeUnfilled.png";
import LikeFilled from "@/assets/icons/likeFilled.png";

import WhiteLikeUnfilled from "@/assets/icons/whiteLikeUnfilled.png";
import WhiteLikeFilled from "@/assets/icons/whiteLikeFilled.png";

import BlueInfoIcon from "@/assets/icons/blueInfoIcon.png";


import "./style.css"
import { useAuthToken } from '@/hooks/useAppSelectors';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { themes } from '@/constants/colors_v2';
import {
    Check,
    ChevronDown,
    CircleCheck,
    Clock,
    ExternalLink,
    FileText,
    Lightbulb,
    RotateCcw,
    X,
} from "lucide-react";

const STUDY_CHECK_STORAGE_KEY = "studycheckshown";

export default function VideoDisView(props: any) {
    const token = useAuthToken()
    const { common } = useLocalTranslation();
    const [notesModalOpen, setNotesModalOpen] = useState(false);
    const [watchStatusModalOpen, setWatchStatusModalOpen] = useState(false);
    /** Study-check banner for the current modal visit (hidden next opens after first). */
    const [studyCheckBannerVisible, setStudyCheckBannerVisible] = useState(false);
    let text_html = "<b>sss sss sss sss sss sss sss sss sss ssssss sss sss sss ssssss sss sss sss sss sss sss sss sss ssssss sss sss sss sss sss sss sss sss sss sss sss sss sss sss</b> <ul><li>d</li></ul>" // testing

    text_html = text_html + "<p>http://localhost:3000/watch?series=65c23e62f5472e869b3e5e2f&video=64e1e9cd961ec06e2416f597http://localhost:3000/watch?series=65c23e62f5472e869b3e5e2f&video=64e1e9cd961ec06e2416f597</p>" // testing

    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    /** Series-level `data.notes` from get-series; not part of each video object. */
    const notesItems = useMemo(() => {
        const raw = props.seriesNotes;
        return Array.isArray(raw) ? raw.filter(Boolean) : [];
    }, [props.seriesNotes]);

    const getDislike_LikeIconAsPerThemeAndStatus = (source: any) => {
        if (source === "like") {
            if (props.videoDetails.isLiked) {
                if (currentTheme === themes.dark) {
                    return WhiteLikeFilled
                } else {
                    return LikeFilled
                }
            } else {
                if (currentTheme === themes.dark) {
                    return WhiteLikeUnfilled
                } else {
                    return LikeUnfilled
                }
            }
        } else { // source === dislike case
            if (props.videoDetails.isDisliked) {
                if (currentTheme === themes.dark) {
                    return WhiteDislikeFilled
                } else {
                    return DislikeFilled
                }
            } else {
                if (currentTheme === themes.dark) {
                    return WhiteDislikeUnfilled
                } else {
                    return DislikeUnfilled
                }
            }
        }
    }

    const openNoteLink = (url: string) => {
        if (!url) return;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const openWatchStatusModal = () => {
        let showStudyBanner = false;
        if (typeof window !== "undefined") {
            try {
                const alreadyShown = localStorage.getItem(STUDY_CHECK_STORAGE_KEY) === "true";
                showStudyBanner = !alreadyShown;
                localStorage.setItem(STUDY_CHECK_STORAGE_KEY, "true");
            } catch {
                /* ignore */
            }
        }
        setStudyCheckBannerVisible(showStudyBanner);
        setWatchStatusModalOpen(true);
    };

    const dismissStudyCheckBanner = () => {
        setStudyCheckBannerVisible(false);
    };

    const isWatched = Boolean(props.videoDetails?.isWatched);

    const applyWatchStatus = async (next: boolean) => {
        const fn = props.handleWatchStatusChange;
        if (!fn) return;
        const ok = await fn(next);
        if (ok) {
            setWatchStatusModalOpen(false);
            setStudyCheckBannerVisible(false);
        }
    };

    console.log("VIDEO DIS", props)

    return (
        <div className={`videoDisView ${addCurrentThemeClassToEle(currentTheme, 'videoDisView')}`}>
            {props.isLoading ?
            // {true ? // testing
                (
                    <div className="animate-pulse space-y-5">
                        {/* Title */}
                        <div className="h-6 w-3/4 videoDisViewLoaderMainCon_gray_300 rounded" />

                        {/* Views */}
                        <div className="h-4 w-24 videoDisViewLoaderMainCon_gray_300 rounded" />

                        {/* Description (3 lines) */}
                        <div className="space-y-4 ">
                            <div className="h-3 w-full videoDisViewLoaderMainCon_gray_300 rounded" />
                            <div className="h-3 w-4/5 videoDisViewLoaderMainCon_gray_300 rounded" />
                        </div>

                        {/* Buttons */}
                        <div className="flex gap-3 mt-3">
                            <div className="h-8 w-12 videoDisViewLoaderMainCon_gray_300 rounded" />
                            <div className="h-8 w-12 videoDisViewLoaderMainCon_gray_300 rounded" />
                            <div className="h-8 w-16 videoDisViewLoaderMainCon_gray_300 rounded" />
                            <div className="h-8 w-20 videoDisViewLoaderMainCon_gray_300 rounded" />
                        </div>
                    </div>
                ) : (
                    <>
                        <p className='title'>
                            {props.videoDetails.title}
                        </p>

                        <p className='views'>
                            {props.videoDetails.amplifyViews > props.videoDetails.viewsCount
                                ? formatNumber(props.videoDetails.amplifyViews)
                                : formatNumber(props.videoDetails.viewsCount)}
                            {' '}
                            {common.statusText.views}
                        </p>

                        {props.videoDetails.description
                            && props.videoDetails.description !== ""
                            && props.videoDetails.description.length > 3 &&
                            <div className='dis'>
                                <ReadMore
                                    bgColor="white"
                                    bulletIcon={null}
                                    // html={text_html} // testing
                                    html={props.videoDetails.description}
                                />
                            </div>
                        }

                        {props.videoDetails.additionalInfo
                            && props.videoDetails.additionalInfo.visible
                            && props.videoDetails.additionalInfo.description !== null
                            && props.videoDetails.additionalInfo.description !== "" &&
                            <div className='additionalInfoCon'>
                                <ReadMore
                                    bgColor="#E8F9FF"
                                    // html={text_html} // testing
                                    html={props.videoDetails.additionalInfo.description}
                                    bulletIcon={props.videoDetails.additionalInfo.bulletIcon} />

                                <img
                                    className='bulletIcon'
                                    src={BlueInfoIcon}
                                    alt='bulletIcon' />

                                {/* {props.videoDetails.additionalInfo.bulletIcon
                                    && props.videoDetails.additionalInfo.bulletIcon !== "" &&
                                    <img
                                        className='bulletIcon'
                                        src={props.videoDetails.additionalInfo.bulletIcon}
                                        alt='bulletIcon' />
                                } */}
                            </div>
                        }

                        <div className='likeShareReportCon'>

                            {token &&
                                <div className='likeDislikeCon con'>

                                    {/* START : Like code */}
                                    <button
                                        onClick={() => { props.handleLike() }}
                                        disabled={props.likeDislikeBtnLoading}
                                        style={{
                                            cursor: props.likeDislikeBtnLoading ? 'not-allowed' : 'pointer',
                                            opacity: props.likeDislikeBtnLoading ? 0.5 : 1
                                        }}
                                    >
                                        <img
                                            className='likeIcon'
                                            src={getDislike_LikeIconAsPerThemeAndStatus("like")}
                                            // src={props.videoDetails.isLiked ? LikeFilled : LikeUnfilled}
                                            alt='likeIcon' />
                                    </button>


                                    {!props.videoDetails.hideLikes &&
                                        <p className='likeCount'>
                                            {props.videoDetails.amplifyLikes > props.videoDetails.likesCount
                                                ? formatNumber(props.videoDetails.amplifyLikes)
                                                : formatNumber(props.videoDetails.likesCount)}
                                        </p>
                                    }
                                    {/* END : Like code */}



                                    {/* START : disLike code */}
                                    <button
                                        onClick={() => { props.handleDislike() }}
                                        disabled={props.likeDislikeBtnLoading}
                                        style={{
                                            cursor: props.likeDislikeBtnLoading ? 'not-allowed' : 'pointer',
                                            opacity: props.likeDislikeBtnLoading ? 0.5 : 1
                                        }}
                                    >
                                        <img
                                            className='dislikeIcon'
                                            src={getDislike_LikeIconAsPerThemeAndStatus("dislike")}
                                            // src={props.videoDetails.isDisliked ? DislikeFilled : DislikeUnfilled}
                                            alt='dislikeIcon' />
                                    </button>
                                    {!props.videoDetails.hideDislikes &&
                                        <p className='dislikeCount'>
                                            {formatNumber(props.videoDetails.dislikesCount)}
                                        </p>
                                    }
                                    {/* END : disLike code */}

                                </div>
                            }
                            {token && (
                                <button
                                    type="button"
                                    className={`watchStatusPill con ${isWatched ? "watchStatusPill--watched" : "watchStatusPill--unwatched"}`}
                                    onClick={openWatchStatusModal}
                                >
                                    {isWatched ? (
                                        <CircleCheck
                                            className="watchStatusPillLeadIcon"
                                            size={18}
                                            strokeWidth={2}
                                            aria-hidden
                                        />
                                    ) : (
                                        <Clock
                                            className="watchStatusPillLeadIcon"
                                            size={18}
                                            strokeWidth={2}
                                            aria-hidden
                                        />
                                    )}
                                    <span className="watchStatusPillLabel">
                                        {isWatched
                                            ? common.statusText.watchedTag
                                            : common.statusText.notWatchedTag}
                                    </span>
                                    <ChevronDown
                                        className="watchStatusPillCaret"
                                        size={16}
                                        strokeWidth={2.5}
                                        aria-hidden
                                    />
                                </button>
                            )}
                            {props?.videoDetails?.showStudyNotes && 
                             props?.videoDetails?.studyNotes?.length > 0 && (
                                <button
                                    type="button"
                                    className="shareBtn con"
                                    onClick={() => setNotesModalOpen(true)}
                                >
                                    <FileText
                                        className="shareIcon"
                                        size={17}
                                        color={currentTheme === themes.dark ? "#ffffff" : "#000000"}
                                    />
                                    Notes
                                </button>
                            )}
                            <button
                                onClick={props.handleShare}
                                className='shareBtn con'>
                                <img
                                    className='shareIcon'
                                    src={currentTheme === themes.dark ? WhiteShare : Share}
                                    alt='share' />
                                {common.statusText.shareBtn}
                            </button>

                            <button
                                onClick={props.handleReport}
                                className='reportBtn con'>
                                <img
                                    className='reportIcon'
                                    src={currentTheme === themes.dark ? WhiteWarning : BlackWarning}
                                    alt='blackWarning' />
                                {common.statusText.reportBtn}
                            </button>
                        </div>
                    </>
                )}

            <Modal
                className={`videoWatchStatusModal01 ${addCurrentThemeClassToEle(currentTheme, "videoWatchStatusModal")}`}
                show={watchStatusModalOpen}
                onHide={() => {
                    setWatchStatusModalOpen(false);
                    setStudyCheckBannerVisible(false);
                }}
                keyboard
                centered
            >
                <div className="videoWatchStatusModalInner">
                    {studyCheckBannerVisible && (
                        <div className="videoWatchStatusStudyBanner">
                            <div className="videoWatchStatusStudyBannerTop">
                                <div className="videoWatchStatusStudyBannerTitleRow">
                                    <span className="videoWatchStatusStudyIconWrap" aria-hidden>
                                        <Lightbulb size={12} strokeWidth={2} />
                                    </span>
                                    <p className="videoWatchStatusStudyHeading">
                                        {common.statusText.studyCheckHeading}
                                    </p>
                                </div>
                                <button
                                    type="button"
                                    className="videoWatchStatusStudyDismiss"
                                    onClick={dismissStudyCheckBanner}
                                    aria-label={common.statusText.studyCheckDismissAria}
                                >
                                    <X size={18} strokeWidth={2} />
                                </button>
                            </div>
                            <p className="videoWatchStatusStudyText">{common.statusText.studyCheckP1}</p>
                            <p className="videoWatchStatusStudyText">{common.statusText.studyCheckP2}</p>
                        </div>
                    )}

                    <p className="videoWatchStatusSectionLabel">
                        {common.statusText.watchStatusSection}
                    </p>
                    <div className="videoWatchStatusSectionRule" />

                    <div className="videoWatchStatusOptions">
                        <button
                            type="button"
                            className={`videoWatchStatusRow ${isWatched ? "videoWatchStatusRow--selected" : ""}`}
                            onClick={() => applyWatchStatus(true)}
                        >
                            <span className="videoWatchStatusRowIcon" aria-hidden>
                                <Check size={16} strokeWidth={2.5}/>
                            </span>
                            <span className="videoWatchStatusRowText">
                                <span className="videoWatchStatusRowTitle">{common.statusText.watchedTag}</span>
                                <span className="videoWatchStatusRowHint">
                                    {common.statusText.markAsWatchedHint}
                                </span>
                            </span>
                        </button>
                        <button
                            type="button"
                            className={`videoWatchStatusRow ${!isWatched ? "videoWatchStatusRow--selected" : ""}`}
                            onClick={() => applyWatchStatus(false)}
                        >
                            <span className="videoWatchStatusRowIcon" aria-hidden>
                                <RotateCcw size={16} strokeWidth={2.5} />
                            </span>
                            <span className="videoWatchStatusRowText">
                                <span className="videoWatchStatusRowTitle">
                                    {common.statusText.notWatchedTag}
                                </span>
                                <span className="videoWatchStatusRowHint">
                                    {common.statusText.markAsNotPlayedHint}
                                </span>
                            </span>
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal
                className={`videoNotesModal01 ${addCurrentThemeClassToEle(currentTheme, "videoNotesModal")}`}
                show={notesModalOpen}
                onHide={() => setNotesModalOpen(false)}
                keyboard
                centered
            >
                <div className="videoNotesModalInner">
                    <div className="videoNotesModalHeader">
                        <h2 className="videoNotesModalTitle">Notes</h2>
                        <button
                            type="button"
                            className="videoNotesModalClose"
                            onClick={() => setNotesModalOpen(false)}
                            aria-label="Close"
                        >
                            <X size={20} strokeWidth={2} />
                        </button>
                    </div>
                    <div className="videoNotesModalDivider" />
                    <ul className="videoNotesModalList">
                        {props?.videoDetails?.studyNotes?.map((item: any, index: number) => {
                            const label = item.title;
                            const href = item.link;
                            return (
                                <li key={item._id ?? href ?? index} className="videoNotesModalCardLi">
                                    <button
                                        type="button"
                                        className="videoNotesModalCard"
                                        onClick={() => openNoteLink(href)}
                                        disabled={!href}
                                        aria-label={href ? `Open ${label}` : label}
                                    >
                                        <span className="videoNotesModalCardTitle">{label}</span>
                                        <span className="videoNotesModalIconWrap" aria-hidden>
                                            <ExternalLink size={18} className="videoNotesModalExtIcon" />
                                        </span>
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </Modal>
        </div>
    );
}


